
import React from 'react';
import AoVivo from './components/AoVivo';


const AoVivoMain = () => <AoVivo />;

export default AoVivoMain;
